import React from 'react'
import { TextField as MuiTextField } from '@material-ui/core'
import Autocomplete from '@material-ui/lab/Autocomplete'
import { Controller } from 'react-hook-form'
import usePlacesAutocomplete, { getGeocode } from 'use-places-autocomplete'
import { FieldError } from './FieldError'
import AddLocationIcon from '@material-ui/icons/AddLocation';
import './FormFields.css'

interface AddressLookupProps {
  control: any
  label: string
  error: any
  name: string
  value?: any
  setField?: any
  fields?: any
}

interface AddressComponent {
  long_name: string
  short_name: string
  types: string[]
}

const parseAddress = (addressComponents: AddressComponent[]) => {
  const address = { streetNumber: '', city: '', route: '', state: '', zip: '' }
  addressComponents.forEach((ac: any) => {
    address.streetNumber = ac.types.includes('street_number') ? ac.short_name : address.streetNumber
    address.route = ac.types.includes('route') ? ac.long_name : address.route
    address.city = ac.types.includes('locality') ? ac.long_name : address.city
    address.state = ac.types.includes('administrative_area_level_1') ? ac.short_name : address.state
    address.zip = ac.types.includes('postal_code') ? ac.short_name : address.zip
  })
  return address
}

export const AddressLookup: React.FC<AddressLookupProps> = ({ label, name, error, control, setField }) => {
  const { suggestions: { data }, setValue, clearSuggestions } = usePlacesAutocomplete()

  const handleAddressSelect = async (address: string) => {
    setField('addressLine1', address.split(',')[0])
    try {
      const results = await getGeocode({ address })
      const addressObj = parseAddress(results[0].address_components)
      const { streetNumber, route, city, state, zip } = addressObj
      setField('addressLine1', `${streetNumber} ${route}`)
      setField('city', city)
      setField('state', state)
      setField('zip', zip)
      clearSuggestions()
    } catch (error) {
      console.error(error)
      clearSuggestions()
    }
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setField('addressLine1', e.target.value)
    setValue(e.target.value)
  }

  return (
    <>
      <Controller
        control={control}
        name={name}
        defaultValue=''
        render={({ onChange, ...props }) => (
          <Autocomplete
            freeSolo
            disableClearable
            options={data.map(s => s.description)}
            renderOption={(option) => <><AddLocationIcon style={{ marginRight: 10 }} />{option}</>}
            renderInput={(params: any) => <MuiTextField {...params} name={name} label={label} margin="normal" onChange={handleChange} />}
            onChange={(_e: any, address: string) => handleAddressSelect(address)}
            onFocus={(e: any) => e.target.autocomplete = 'no'}
            {...props}
          />
      )}
    />
    <FieldError fieldError={error} />
    </>
  )
}